
import WebFont from 'webfontloader'

const options = {"custom":{"families":["glossy-display","robotomono-regular","WorkSans-Regular"],"urls":["\u002Ffonts.css"]},"active":() => {
      window.dispatchEvent(new Event('fonts.loaded'));
      window._fontsAreLoaded = true;
    }}

WebFont.load(options)
